// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__38S9v","resendInfoText":"OnGoingPaymentBox_resendInfoText__11_ad"};